





















import { customer } from "@/store"
import Vue from "vue"
import Component from "vue-class-component"

@Component
export default class Footer extends Vue {
  locales = ["ua", "ru"]

  get currentLanguage() {
    return this.$i18n.locale
  }

  changeLocale(locale: string) {
    if (locale == this.$i18n.locale) {
      return
    }
    customer.changeLocale(locale)
    this.$i18n.locale = locale
  }
}
